import client, { ApiResponse } from './client';

export interface NonceResponse {
  nonce: string;
  message: string;
}

export const getNonce = async (address: string): Promise<NonceResponse> => {
  const response = await client.get<ApiResponse<NonceResponse>>('/auth/nonce', {
    params: { address },
  });
  return response.data.data;
};

export interface UserInfo {
  nickname: string;
  level: number;
  isNewUser?: boolean;
}

export interface LoginResponse {
  token: string;
  expireIn: number;
  userInfo: UserInfo;
}

export const login = async (
  address: string,
  signature: string,
  nonce: string,
  invitationCode?: string
): Promise<LoginResponse> => {
  const response = await client.post<ApiResponse<LoginResponse>>('/auth/login', {
    address,
    signature,
    nonce,
    invitationCode,
  });
  return response.data.data;
};
